import { v4 } from 'uuid';
import { getUserIdFromCookie } from './auth';

type GetUserIdParams = {
  analyticsCookie?: string;
  jgAuthCookie?: string;
};

export function getUserId({ analyticsCookie, jgAuthCookie }: GetUserIdParams) {
  if (analyticsCookie) {
    return (
      new URLSearchParams(analyticsCookie).get('logged_out_guid') ?? undefined
    );
  }

  if (jgAuthCookie) {
    const jgUserId = getUserIdFromCookie(jgAuthCookie);

    if (jgUserId) return jgUserId;
  }

  return v4();
}

export function getDeviceType(userAgent?: string | null) {
  if (!userAgent) {
    return 'Unknown';
  }

  return userAgent.match(/Mobi/) ? 'Mobile' : 'Desktop';
}
